import {
  useGetUserChoiceBoards,
  useDeleteChoiceBoard,
  getGetUserChoiceBoardsQueryKey,
  useGetTopChoiceBoards,
  likeChoiceBoard,
  unlikeChoiceBoard,
  getGetTopChoiceBoardsQueryKey,
} from "@packages/api/madlenAPI";
import GenericToolPage from "../../components/tool_components/GenericToolPage";
import ChoiceBoardCard, {
  Choice,
} from "@features/tools/components/choice-boards/ChoiceBoards";

interface ExtendedTool {
  id: number;
  imageUrl?: string;
  prompt?: string;
  title?: string;
  authorName?: string;
  likeCount?: number;
  courseName?: string;
  gradeLevel?: number;
  didUserLiked?: boolean;
  description?: string;
  activities?: Choice[];
  videoUrl?: string;
  createdAt?: string;
  isEditable?: boolean;
}

const ChoiceBoardDetailComponent = ({ tool }: { tool: ExtendedTool }) => {
  return <ChoiceBoardCard tool={tool} isEditable={tool.isEditable} />;
};

const ChoiceBoardsView = () => {
  return (
    <GenericToolPage
      useGetTools={useGetUserChoiceBoards}
      useDeleteTool={useDeleteChoiceBoard}
      getGetToolsQueryKey={getGetUserChoiceBoardsQueryKey}
      useGetTopTools={useGetTopChoiceBoards}
      likeTool={likeChoiceBoard}
      unlikeTool={unlikeChoiceBoard}
      getGetTopToolsQueryKey={getGetTopChoiceBoardsQueryKey}
      toolType="choiceBoards"
      toolPath="choice-boards"
      DetailComponent={ChoiceBoardDetailComponent}
      colors={{
        light: "from-green-600 to-emerald-600",
        dark: "dark:from-green-400 dark:to-emerald-400",
        iconBg: "bg-green-100 dark:bg-green-900/50",
        iconColor: "text-green-600 dark:text-green-400",
        hover: "hover:bg-green-50 dark:hover:bg-green-900/20",
      }}
      toolColor="green"
      gradientColor="purple"
    />
  );
};

export default ChoiceBoardsView;
